const defaultConfig = {
  apiKey: 'AIzaSyDBAwfAhPordwFW6qhKXI9pp9S_VO1x_Lw',
  lat: 0,
  lng: 0,
  zoom: 3,
  maxZoom: 16,
  scrollwheel: false,
};

export default class GoogleMap {
  constructor(selector = '.googlemap', config) {
    this.selector = selector;
    this.config = { ...defaultConfig, ...config };

    this.maps = [];

    this._init();

    return this;
  }

  _init() {
    this.maps.push.apply(this.maps, document.querySelectorAll(this.selector));

    if (this.maps.length) {
      const mapsTag = document.createElement('script');
      mapsTag.setAttribute('type', 'text/javascript');
      mapsTag.setAttribute(
        'src',
        `https://maps.googleapis.com/maps/api/js?key=${this.config.apiKey}&callback=window.myApp.googlemaps._loadMap`,
      );
      document.body.appendChild(mapsTag);
    }

    return this.maps;
  }

  _loadMap() {
    this.maps = this.maps.map(map => {
      const mapObj = {
        wrapper: map,
        instance: null,
        markers: [],
      };

      mapObj.instance = new window.google.maps.Map(map, {
        center: {
          lat: parseFloat(map.getAttribute('data-lat'), 10),
          lng: parseFloat(map.getAttribute('data-lng'), 10),
        },
        zoom: map.getAttribute('data-zoom')
          ? parseFloat(map.getAttribute('data-zoom'), 10)
          : this.config.zoom,
        maxZoom: this.config.maxZoom,
        scrollwheel: this.config.scrollwheel,
      });

      const markerInstance = new window.google.maps.Marker({
        position: {
          lat: parseFloat(map.getAttribute('data-lat'), 10),
          lng: parseFloat(map.getAttribute('data-lng'), 10),
        },
        map: mapObj.instance,
      });

      mapObj.marker = markerInstance;

      return mapObj;
    });
  }
}



// WEBPACK FOOTER //
// ./app/scripts/modules/Googlemap.js